  <template>
  <!-- <div> -->
  <el-dialog title="添加文章" :visible.sync="dialogVisible" width="42%">
    <el-form
      ref="ruleForm"
      :rules="rules"
      :model="ruleForm"
      label-width="120px"
    >
      <el-form-item label="资讯标题" prop="title">
        <el-col :span="15">
          <el-input
            v-model="ruleForm.title"
            placeholder="请输入资讯标题"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="类型" prop="description">
        <el-col :span="15">
          <el-input
            v-model="ruleForm.description"
            placeholder="请输入类型"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="封面图" prop="front_cover">
        <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :on-success="uploadImg"
          :limit="20"
          :file-list="fileList_img"
          accept=".jpg,.jpeg,.png"
        >
          <el-button size="small" type="primary"> + 上传</el-button>
          <div slot="tip" class="el-upload__tip">
            支持格式jpg/png文件，最多上传20张图片
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div v-loading="quillUpdateImg" element-loading-text="请稍等，图片上传中">
      <!-- 图片上传组件辅助-->
      <el-upload
        class="avatar-uploader"
        :action="serverUrl"
        name="file"
        :headers="header"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload"
      >
      </el-upload>
      <quill-editor
        class="editor"
        v-model="content"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
      >
      </quill-editor>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
  <!-- </div> -->
</template>
  
  <script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Api from "@/api";
// 工具栏配置
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],                         // 文本方向
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image", "video"], // 链接、图片、视频
];

export default {
  name: "addarticle",
  components: {
    quillEditor,
  },
  props: {
    callback: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      editArticle: false,
      uploadUrl: process.env.VUE_APP_BASEURL + "/common/file/upload",
      ruleForm: {
        product_id: "",
        product_type: "3",
        title: "",
        description: "",
        front_cover: "",
        body: "",
      },
      fileList_img: [],
      rules: {
        title: [
          { required: true, message: "请填写资讯标题", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        description: [
          { required: true, message: "请填写类型", trigger: "blur" },
          { min: 1, max: 5, message: "最多 5 个字符", trigger: "blur" },
        ],
      },
      serverUrl: process.env.VUE_APP_BASEURL + "/common/file/upload", // 这里写你要上传的图片服务器地址
      header: {
        // 有的图片服务器要求请求头需要有token，有的可以加上
        Authorization: "Bearer ",
      },
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      content: "", // 内容
      editorOption: {
        // 配置项
        placeholder: "",
        theme: "snow", // or 'bubble'
        placeholder: "请输入文章内容",
        modules: {
          toolbar: {
            container: toolbarOptions,
            // container: "#toolbar",
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              link: function (value) {
                if (value) {
                  var href = prompt("注意！只支持公众号图文链接");
                  this.quill.format("link", href);
                } else {
                  this.quill.format("link", false);
                }
              },
            },
          },
        },
      },
    };
  },
  methods: {
    open(id) {
      this.dialogVisible = true;
      this.ruleForm = {
        product_id: id,
        product_type: "3",
        title: "",
        description: "",
        front_cover: "",
        body: "",
      };
      this.fileList_img = [];
      this.editArticle = false;
    },
    edit(row) {
      this.dialogVisible = true;
      this.ruleForm = row;
      this.content = row.body;
      this.editArticle = true;
      this.fileList_img = row.front_cover
        ? [{ name: row.front_cover, url: row.front_cover_url }]
        : [];
    },
    uploadImg(res, file) {
      this.ruleForm.front_cover = res.data.key;
      console.log(this.fileList_img);
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editArticle) {
            Api.post.editArticleJob(this.ruleForm).then((res) => {
              this.dialogVisible = false;
              this.callback && this.callback();
            });
          } else {
            Api.post.addArticleJob(this.ruleForm).then((res) => {
              this.dialogVisible = false;
              this.callback && this.callback();
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /**
     * 富文本方法
     */
    onEditorBlur(editor) {
      //失去焦点事件
      console.log(this.content);
    },
    onEditorFocus(editor) {
      //获得焦点事件
    },
    onEditorChange(editor) {
      this.ruleForm.body = this.content;
      // console.log(this.ruleForm)
    },
    // 富文本图片上传前
    beforeUpload() {
      // 显示loading动画
      this.quillUpdateImg = true;
    },
    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      console.log(res);
      if (res.data.key) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.data.url);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    // 富文本图片上传失败
    uploadError() {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片插入失败");
    },
  },
};
</script>
  <style  lang='scss' scoped>
</style>